import { FC, ReactElement } from "react";
import { IconButton, makeStyles } from "@material-ui/core";

interface PropsType {
  icon: ReactElement<any, any>;
  iconColor: "white" | "red" | "blue" | "darkGray";
  theme: "blank" | "red" | "green" | "gray" | "blue";
  action?: any;
  disabled?: boolean;
}

const CustomIconButton: FC<PropsType> = ({ icon, iconColor, theme, action, disabled }) => {
  const classes = useStyles();

  return (
    <IconButton
      className={`${classes.root} ${classes[`${iconColor}Color`]} ${classes[`${theme}Theme`]}`}
      onClick={(e) => action ? action(e) : null }
      disabled={disabled}
    >
      {icon}
    </IconButton>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    transition: "0.3s",
    width: 40,
    height: 40,
    borderRadius: 5,
    "MuiTouchRipple-root": {
      borderRadius: 5,
    },
  },
  whiteColor: {
    color: "white",
  },
  redColor: {
    color: "#C42020",
  },
  darkGrayColor: {
    color: "#5F6164",
  },
  blueColor: {
    color: "#0129FA",
  },
  blankTheme: {},
  redTheme: {
    background: "#C42020",
    "&:hover": {
      background: "#881414",
    },
  },
  greenTheme: {
    background: "#1B7E43",
    "&:hover": {
      background: "#145E32",
    },
  },
  grayTheme: {
    background: "#EAECEC",
  },
  blueTheme: {
    background: "#0129FA",
    "&:hover": {
      background: "#0021c5",
    },
  },
}));

export default CustomIconButton;
